module.exports = "/_next/static/images/money-duotone-8a709f626eaab0a74d7308ddd0f827d8.svg";